module.exports = __webpack_public_path__ + "img/logorobotpremio.c606e465.jpg";